module.exports = __webpack_public_path__ + "img/circularStrategy11.91c86f9b.png";